import { getVersionForClone } from '@qr-front/ui/utils'

import { BasePlaceholder } from './BasePlaceholder'
import { Clone1Placeholder } from './Clone1Placeholder'

export const Placeholder = getVersionForClone({
	base: BasePlaceholder,
	clone1: Clone1Placeholder,
})
